export const HOME_PROFILE_V2_REQUEST = "HOME_PROFILE_V2_REQUEST"
export const HOME_PROFILE_V2_SUCCESS = "HOME_PROFILE_V2_SUCCESS"
export const HOME_PROFILE_V2_FALUIRE = "HOME_PROFILE_V2_FALUIRE"

export const GET_PROFILE_V2_REQUEST = "GET_PROFILE_V2_REQUEST"
export const GET_PROFILE_V2_SUCCESS = "GET_PROFILE_V2_SUCCESS"
export const GET_PROFILE_V2_FALUIRE = "GET_PROFILE_V2_FALUIRE"
